import { useMutation } from '@src/query';


/**
 * Settings → Team mutation hooks (T10). Each wraps the shared `useMutation`
 * engine with the injected-`queryClient` `mutateFn({ apiClient })` contract —
 * the corelib query singleton is NOT imported here. The Team page refreshes the
 * roster with `teamQuery.refetch()` in its `onSuccess` callbacks (it always has),
 * so these hooks perform no cache invalidation — behavior preserved exactly.
 *
 * Mirrors `query/garage/useDonorMutations.js`.
 */

/** PATCH a member's role or DELETE the member. Variables: `{ sellerId, method,
 * membershipId, payload }`. */
function useMemberMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, sellerId, method, membershipId, payload }) => apiClient.request({
      url: `/sellers/${sellerId}/members/${membershipId}/`,
      method,
      payload,
    }),
    ...params,
  });
}


/** Resend or revoke a pending invite. Variables: `{ sellerId, invitationId,
 * action }` where `action` is `'resend' | 'revoke'`. */
function useInviteActionMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, sellerId, invitationId, action }) => apiClient.request({
      url: `/sellers/${sellerId}/invites/${invitationId}/${action}/`,
      method: 'POST',
    }),
    ...params,
  });
}


/** Send a single invite. Variables: `{ sellerId, payload }`. The InviteModal
 * sends one POST per email and aggregates per-email failures itself. */
function useInviteSendMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, sellerId, payload }) => apiClient.request({
      url: `/sellers/${sellerId}/invites/`,
      method: 'POST',
      payload,
    }),
    ...params,
  });
}


export {
  useInviteActionMutation,
  useInviteSendMutation,
  useMemberMutation,
};
